import classnames from 'classnames';
import React from 'react';
import { useWizard } from 'react-use-wizard';
import Icon from '../icon/Icon';
import { noop } from 'lodash';
var BreadcrumbStep = function(param) {
    var stepIndex = param.stepIndex, stepLabel = param.stepLabel, name = param.name, disabled = param.disabled;
    var _useWizard = useWizard(), goToStep = _useWizard.goToStep, activeStep = _useWizard.activeStep;
    var handleClick = function() {
        goToStep(stepIndex);
    };
    var isVisited = activeStep > stepIndex;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('BreadcrumbStep', {
            visited: isVisited,
            isCurrentStep: activeStep === stepIndex
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "thread"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "globe",
        onClick: !disabled ? handleClick : noop
    }, isVisited && activeStep !== stepIndex ? /*#__PURE__*/ React.createElement(Icon, {
        icon: "tick"
    }) : stepLabel), /*#__PURE__*/ React.createElement("p", {
        className: "name mb-0"
    }, name));
};
export default BreadcrumbStep;
